import { render, staticRenderFns } from "./aftersale.vue?vue&type=template&id=17f472fc&scoped=true"
import script from "./aftersale.vue?vue&type=script&lang=js"
export * from "./aftersale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f472fc",
  null
  
)

export default component.exports